
import React from "react"


export default function Navbar(){

    return(
    <footer className="site-footer">
      <div className="footer-content">
        <div className="footer-column">
          <h3>Capabilities</h3>
          <ul>
            <li>Web Development</li>
            <li>Mobile Development</li>
            <li>UI/UX Design</li>
            <li>AI/ML</li>
            <li>AR/VR</li>
            <li>Game Development</li>
            <li>Interactive Experiences</li>
          </ul>
        </div>
        <div className="footer-column">
          <h3>Brands</h3>
          <ul>
            <li>Nike</li>
            <li>Pepsi, Mountain Dew, Starry</li>
            <li>Toyota</li>
            <li>Sony</li>
            <li>AT&T</li>
            <li>Progressive</li>
            <li>Lay's</li>
            <li>Quaker</li>
            <li>Corona</li>
            <li>USAA Real Estate / Affinius Capital</li>
            <li>Cap'n Crunch</li>
            <li>MiracleGro</li>
            <li>Calbee</li>
            <li>Phillips Norelco</li>
          </ul>
        </div>
        <div className="footer-column">
          <h3>Verticals</h3>
          <ul>
            <li>Telecom</li>
            <li>Food & Beverage</li>
            <li>Automotive</li>
            <li>Finance</li>
            <li>Insurance</li>
            <li>Healthcare</li>
            <li>Sports</li>
            <li>Entertainment / Gaming</li>
            <li>Retail / E-Commerce</li>
            <li>AI / Emerging Tech</li>
          </ul>
        </div>
        <div className="footer-column">
          <h3>Acheivements Unlocked</h3>
          <ul>
            <li>Masters in Neuroscience</li>
            <li>Tim Cook liked my work</li>
            <li>Memorized 1000 digits of pi</li>
            <li>Published Sleep Scientist</li>
            <li>300+ improv comedy shows</li>
            <li>Beat Portal 2 two-player solo</li>
            <li>Helped Ron Jeremy find a book</li>
          </ul>
        </div>
      </div>
    </footer>
  )
}